<div class="main-content table-page table-page--compact hom">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Comparativa de Modelos IA</h1>
        <p>En qué es mejor cada modelo, medido con la misma vara. Solo consulta: el detalle completo y el dictamen están en Homologación de Modelos IA.</p>
      </div>
    </section>

    <nav class="hom-pestanas" aria-label="Secciones">
      <button type="button" class="hom-pestanas__item" [class.is-activa]="pestana === 'comparativa'" [attr.aria-current]="pestana === 'comparativa' ? 'page' : null" (click)="irA('comparativa')">1 · Comparativa</button>
      <button type="button" class="hom-pestanas__item" [class.is-activa]="pestana === 'modelos'" [attr.aria-current]="pestana === 'modelos' ? 'page' : null" (click)="irA('modelos')">2 · Modelos</button>
      <button type="button" class="hom-pestanas__item" [class.is-activa]="pestana === 'resultado'" [attr.aria-current]="pestana === 'resultado' ? 'page' : null" [disabled]="!hayResultado" (click)="irA('resultado')">3 · Resultado</button>
    </nav>

    @if (pestana === "comparativa") {
      <app-comparativa-modelos (abrir)="abrirResumen($event)"></app-comparativa-modelos>
    } @else if (pestana === "modelos") {
      <section class="table-page__card">
        <div class="table-page__table-wrap">
          @if (modelos.length) {
            <table class="table-page__table">
              <thead>
                <tr>
                  <th scope="col">Modelo</th>
                  <th scope="col">Dictamen</th>
                  <th scope="col">Veredicto del harness</th>
                  <th scope="col">Última evaluación</th>
                  <th scope="col" class="table-page__actions-head">Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (m of modelosPagina; track m.idEval) {
                  <tr>
                    <td>
                      <div class="table-page__cell-stack">
                        <span class="table-page__name">{{ m.nombre }}</span>
                        @if (m.nombreConfiguracion) {
                          <span class="table-page__subtext">{{ m.nombreConfiguracion }}</span>
                        }
                        <span class="table-page__subtext"><code class="hom-mono">{{ m.identificador }}</code></span>
                      </div>
                    </td>
                    <td>
                      @if (m.vigente) {
                        <span class="table-page__status-badge is-active">Vigente</span>
                      } @else if (m.dictamen) {
                        <span class="table-page__status-badge" [class]="'table-page__status-badge ' + dictamenClase(m.dictamen)">{{ dictamenTexto(m.dictamen) }}</span>
                      } @else {
                        <span class="table-page__subtext">Sin dictamen</span>
                      }
                    </td>
                    <td><span class="table-page__text">{{ veredictoTexto(m.veredicto) }} {{ coletilla(m.estatus) }}</span></td>
                    <td>
                      <div class="table-page__cell-stack">
                        <span class="table-page__text">
                          {{ m.aplicadaDesde || m.fechaCarga || "—" }} ·
                          @if (num(m.capacidad) !== null) { <strong>{{ m.capacidad | number: "1.1-1" }}</strong> } @else { — }
                        </span>
                        <span class="table-page__subtext">corrida <code class="hom-mono">{{ m.runId }}</code></span>
                      </div>
                    </td>
                    <td class="table-page__actions">
                      <button type="button" class="table-page__action-btn" [attr.aria-label]="'Ver resultado de ' + m.nombre" title="Ver resultado" (click)="abrirResumen(m.idEval)">
                        <i class="material-icons" aria-hidden="true">insights</i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else if (cargandoModelos) {
            <div class="table-page__empty">
              <i class="material-icons" aria-hidden="true">hourglass_top</i>
              <strong>Cargando modelos…</strong>
            </div>
          } @else if (errorModelos) {
            <div class="table-page__empty" role="alert">
              <i class="material-icons" aria-hidden="true">error_outline</i>
              <strong>{{ errorModelos }}</strong>
              <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargarModelos()">Reintentar</button>
            </div>
          } @else {
            <div class="table-page__empty">
              <i class="material-icons" aria-hidden="true">fact_check</i>
              <strong>Todavía no hay modelos evaluados</strong>
            </div>
          }
        </div>

        @if (modelos.length > POR_PAGINA) {
          <div class="table-page__footer">
            <div class="table-page__meta"><span>{{ modelos.length }} modelos</span></div>
            <div class="table-page__pager">
              <button type="button" class="table-page__pager-link" [disabled]="pagina === 1" (click)="irAPagina(pagina - 1)">Anterior</button>
              @for (n of paginas; track n) {
                <button type="button" class="table-page__pager-page" [class.is-current]="n === pagina" [attr.aria-current]="n === pagina ? 'page' : null" (click)="irAPagina(n)">{{ n }}</button>
              }
              <button type="button" class="table-page__pager-link" [disabled]="pagina === totalPaginas" (click)="irAPagina(pagina + 1)">Siguiente</button>
            </div>
          </div>
        }
      </section>
    } @else {
      @if (cargandoResumen) {
        <section class="table-page__card">
          <div class="table-page__empty">
            <i class="material-icons" aria-hidden="true">hourglass_top</i>
            <strong>Abriendo el resultado…</strong>
          </div>
        </section>
      } @else if (errorResumen) {
        <section class="table-page__card">
          <div class="table-page__empty" role="alert">
            <i class="material-icons" aria-hidden="true">error_outline</i>
            <strong>{{ errorResumen }}</strong>
          </div>
        </section>
      } @else if (resumen) {
        <app-resultado-resumido [resumen]="resumen" [ficha]="ficha"></app-resultado-resumido>
      }
    }
  </div>
</div>
